import './page.scss';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const Agreement = () => {
  const { id } = useParams();
  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) el.scrollIntoView({ behavior: 'auto' });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>User agreement – Naijads.ng</title>
        <meta
          name="description"
          content="Read Naijads.ng Terms of Use to understand your rights and responsibilities when posting free classifieds across Nigeria."
        />
        <link rel="canonical" href="https://naijads.ng/agreements" />
        <meta property="og:title" content="User Agreement – Naijads.ng" />
        <meta
          property="og:description"
          content="Learn how to use Naijads.ng responsibly. See your rights, duties, and what’s not allowed."
        />
        <meta property="og:url" content="https://naijads.ng/agreements" />
        <meta property="og:type" content="article" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'PolicyPage',
            name: 'User Agreement – Naijads.ng',
            url: 'https://naijads.ng/agreements',
            description:
              'Read Naijads.ng Terms of Use to understand your rights and responsibilities when posting free classifieds across Nigeria.',
            about: {
              '@type': 'Organization',
              name: 'Naijads.ng',
              url: 'https://naijads.ng',
              logo: {
                '@type': 'ImageObject',
                url: 'https://naijads.ng/assets/Tayo.svg',
              },
            },
          })}
        </script>
      </Helmet>

      <div className="info-page">
        <div className="info-block-main">
          <h1>User Agreement</h1>
          <p>
            Welcome to <strong>Naijads.ng</strong>. This agreement outlines the rights and responsibilities between you (our dear user) and Naijads. By using our website,
            mobile app, or related services (“Services”), you agree to follow these terms, as well as our <a href="/privacy-policy">Privacy Policy</a> and <a href="/advertisers">Prohibited Content Guidelines</a>.
          </p>
        </div>

        <div className="info-block">
          <h3>Your account</h3>
          <p>
            To use certain features (like posting or messaging), you need to register using a valid email, phone number, or social login. You’re responsible for keeping
            your password secure and not sharing your login with others. Naijads is not liable for any unauthorized access caused by careless handling of your account.
            If you suspect misuse or a breach, kindly reach out to <a href="/feedback">Naijads Support</a>.
          </p>
        </div>

        <div className="info-block">
          <h3>Using naijads Properly</h3>
          <p>
            You agree to:
            <ul>
              <li>Post honest, accurate listings in the correct category</li>
              <li>Not post illegal, harmful, or misleading content</li>
              <li>Avoid spamming, impersonation, or promoting scams</li>
              <li>Respect other users — no harassment or abuse allowed</li>
              <li>Not use bots or scrapers to collect data from Naijads</li>
              <li>Only offer goods or services you have rights to sell</li>
            </ul>
          </p>
        </div>

        <div className="info-block">
          <h3>Legal compliance</h3>
          <p>
            All ads and messages must comply with Nigerian laws and ethical standards. Naijads reserves the right to suspend or delete any listing or account that violates
            this agreement or puts our community at risk.
          </p>
        </div>

        <div className="info-block">
          <h3>Changes to this Agreement</h3>
          <p>
            Naijads.ng may update these terms occasionally to reflect legal, platform, or community changes. Continued use of the service means you accept the latest version.
            We encourage you to check back here from time to time.
          </p>
        </div>

        <div className="info-block-main">
          <p>
            Thank you for choosing Naijads. Our goal is to create a safe and vibrant platform for all Nigerians to buy, sell, and connect. Let's keep things clean and
            community-minded.
          </p>
        </div>
      </div>
    </>
  );
};

export default Agreement;
